import { LOCAL_STORAGE_KEY } from "~~/constant/tracking.constant";

const isSuccessUpdate = ref<boolean>(false)
const badgeTimer = ref<ReturnType<typeof setTimeout> | null>(null);
const lastUpdate = ref()

export const useUpdateBadge = () => {

    const showBadgeWithReset = () => {
        if (badgeTimer.value) {
            clearTimeout(badgeTimer.value);
        }

        isSuccessUpdate.value = true;

        badgeTimer.value = setTimeout(() => {
            isSuccessUpdate.value = false;
            badgeTimer.value = null;
        }, 3000);
    };

    function formatTimestamp(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }

        const formatted = date
            .toLocaleDateString("id-ID", options)
            .replace(/\./g, ":")

        return `${formatted} WIB`
    }

    function getLastUpdate(key: string): string {

        if (!import.meta.client) {
            return "-"
        }

        if (key === LOCAL_STORAGE_KEY.TrackingCrew) {
            const saved = localStorage.getItem(key)
            if (saved) return lastUpdate.value = saved
        }

        if (key === LOCAL_STORAGE_KEY.ThreePL) {
            const saved = localStorage.getItem(key)
            if (saved) return lastUpdate.value = saved
        }

        return setLastUpdate(key)
    }

    function setLastUpdate(key: string): string {

        const timestamp =
            formatTimestamp(new Date())

        if (import.meta.client) {
            localStorage.setItem(key, timestamp)
        }

        return timestamp
    }

    return {
        getLastUpdate,
        setLastUpdate,
        showBadgeWithReset,
        isSuccessUpdate,
        lastUpdate,
    }
}